export const isHTMLElement = (x: unknown): boolean => x instanceof HTMLElement
